<template>
  <div class="c--about-us_teams-startup-section teams-startup-section-wrapper py-20 py-md-30 py-lg-40 px-20 px-md-30">
    <div class="new-container mx-auto">
      <div class="teams-startup-section-container">
        <h2 v-if="false" class="teams-startup-section-title">
          {{ $t('components.about.us.teams.team-startups-title') }}
        </h2>
        <p v-if="false" class="teams-startup-section-subtitle">
          {{ $t('components.about.us.teams.team-startups-subtitle') }}
        </p>
        <div class="tw-flex tw-w-full tw-justify-center tw-items-start tw-flex-wrap tw-gap-5 md:tw-gap-7.5">
          <div
            v-for="(boxItem, key) in boxItems"
            :key="`teams-startup-section-box-${key}`"
            class="teams-startup-section-box"
          >
            <p class="teams-startup-section-box-title" v-if="boxItem.title">
              {{ boxItem.title }}
            </p>
            <p class="teams-startup-section-box-subtitle" v-if="boxItem.subtitle">
              {{ boxItem.subtitle }}
            </p>

            <a-icon
              class="tw-block sm:tw-hidden"
              type="class"
              loader="raw"
              name="website-expansion-content-box-bg-sm"
            />
            <a-icon class="tw-hidden sm:tw-block" type="class" loader="raw" name="website-expansion-content-box-bg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'teams-startup-section',

    data() {
      return {
        isMobile: false,
        boxItems: [
          {
            title: this.$t('components.about.us.teams.team.startups.box-1-title'),
            subtitle: this.$t('components.about.us.teams.team.startups.box-1-subtitle'),
          },
          {
            title: this.$t('components.about.us.teams.team.startups.box-2-title'),
            subtitle: this.$t('components.about.us.teams.team.startups.box-2-subtitle'),
          },
          {
            title: this.$t('components.about.us.teams.team.startups.box-3-title'),
            subtitle: this.$t('components.about.us.teams.team.startups.box-3-subtitle'),
          },
        ],
      }
    },
  }
</script>

<style lang="scss" scoped>
  .teams-startup-section-wrapper {
    background-color: #fff;

    .teams-startup-section-container {
      .teams-startup-section-title {
        color: #4a4a4a;
        font-size: 27px;
        font-weight: 600;
        letter-spacing: -0.5px;
        line-height: 32px;
        text-align: center;
        max-width: 65%;
        margin: 0 auto 10px;
      }

      .teams-startup-section-subtitle {
        color: #8a8a8a;
        font-size: 15px;
        letter-spacing: 0;
        line-height: 21px;
        text-align: center;
        max-width: 65%;
        margin: 0 auto;
      }

      .teams-startup-section-box {
        position: relative;
        z-index: 2;
        overflow: hidden;
        padding: 20px;
        border-radius: 7px;
        background-color: #ffffff;
        box-shadow: 0 10px 30px 0 rgba(0, 0, 0, 0.15);
        width: 100%;
        height: 230px;
        max-width: calc((100% - 60px) / 3);
        flex: 1 0 310.6666666667%;

        .teams-startup-section-box-title {
          color: #4a4a4a;
          font-size: 31px;
          font-weight: 600;
          letter-spacing: -0.6px;
          line-height: 37px;
          margin-bottom: 3px;
        }

        .teams-startup-section-box-subtitle {
          color: #8a8a8a;
          font-size: 15px;
          letter-spacing: 0;
          line-height: 21px;
          margin-bottom: 0;
        }

        ::v-deep .icon-website-expansion-content-box-bg,
        ::v-deep .icon-website-expansion-content-box-bg-sm {
          background-repeat: no-repeat;
          width: 100%;
          height: 100%;
          z-index: -1;
          position: absolute;
          top: 0;
          left: 0;
        }

        ::v-deep .icon-website-expansion-content-box-bg {
          background-position: center;
          background-size: cover;
        }

        ::v-deep .icon-website-expansion-content-box-bg-sm {
          background-position: right;
          background-size: auto 100%;

          [dir='rtl'] & {
            transform: rotateY(180deg);
          }
        }
      }
    }
  }

  @media only screen and (max-width: 767px) {
    .teams-startup-section-wrapper {
      .teams-startup-section-container {
        .teams-startup-section-box {
          height: 170px;
          max-width: calc((100% - 30px) / 2);
          flex: 1 0 369%;
        }

        .teams-startup-section-title,
        .teams-startup-section-subtitle {
          max-width: 85%;
        }
      }
    }
  }

  @media only screen and (max-width: 575px) {
    .teams-startup-section-wrapper {
      .teams-startup-section-container {
        .teams-startup-section-title {
          font-size: 19px;
          line-height: 22px;
        }

        .teams-startup-section-box {
          height: 126px;
          max-width: unset;
          flex: 1 0 100%;
        }
        .teams-startup-section-subtitle {
          max-width: 100%;
        }
      }
    }
  }
</style>
